import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './Home/home';
import AuthCallback from './AuthCallback/AuthCallback';
import Articleship from './Articleship/Articleship';
import DirectChat from './DirectChat/DirectChat';
import CallPage from './Call/CallPage';
import BhupendraPatelCallPage from './Call/BhupendraPatelCallPage';
import GujaratGovtCallPage from './Call/GujaratGovtCallPage';
import UserDashboard from './UserDashboard/UserDashboard';
import GovtDashboard from './GovtDashboard/GovtDashboard';
import AdaniDashboard from './AdaniDashboard/AdaniDashboard';
import ChaimateClubLanding from './ChaimateClub/ChaimateClubLanding';
import LendingKart from './LendingKart/LendingKart';
import AstroDeepak from './AstroDeepak/AstroDeepak';
import ApiDocs from './ApiDocs/ApiDocs';
import Dashboard from './Dashboard/Dashboard';
import GmmIntel from './GmmIntel/GmmIntel';
import { ErrorBoundary } from "react-error-boundary";
import notAvailableImage from './images/not-available-img.svg';
import { retryFailedRequests } from "./utils/api";
import { useEffect, useState } from 'react';
import ReactPixel from 'react-facebook-pixel';

const handleVisibilityChange = () => {
  if (!document.hidden) {
    console.log('Tab is now active, retrying failed requests...');
    retryFailedRequests();
  } else {
    console.log('Tab is now hidden');
  }
};

// Page focus handler (additional Safari support)
const handlePageFocus = () => {
  console.log('Page focused, retrying failed requests...');
  retryFailedRequests();
};

// Initialize tab visibility detection
export const initializeTabVisibilityDetection = () => {
  // Primary method - visibility API
  document.addEventListener('visibilitychange', handleVisibilityChange);

  // Fallback methods for better Safari support
  window.addEventListener('focus', handlePageFocus);
  window.addEventListener('pageshow', handlePageFocus);

  // Cleanup function
  return () => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);
    window.removeEventListener('focus', handlePageFocus);
    window.removeEventListener('pageshow', handlePageFocus);
  };
};

function ErrorFallback({ error }) {
  const message = error?.message || String(error || 'Something went wrong');

  return (
    <div className="app-error-fallback" role="alert">
      <img
        className="app-error-fallback__illustration"
        src={notAvailableImage}
        alt=""
        width={200}
        height={160}
        decoding="async"
      />
      <div className="app-error-fallback__title">CA Circle is under maintenance</div>
      <p className="app-error-fallback__hint">
        If this keeps happening, try again in a moment or refresh the page.
      </p>
      <details className="app-error-fallback__details">
        <summary className="app-error-fallback__summary">Technical details</summary>
        <pre className="app-error-fallback__pre">{message}</pre>
      </details>
      <button type="button" className="app-error-fallback__retry" onClick={() => window.location.reload()}>
        Retry
      </button>
    </div>
  );
}

function readStoredDarkMode() {
  try {
    const stored = localStorage.getItem('darkMode');
    if (stored === null) return true;
    return stored === 'true';
  } catch {
    return true;
  }
}

function App() {
  const [darkMode, setDarkMode] = useState(readStoredDarkMode);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
    try {
      localStorage.setItem('darkMode', String(darkMode));
    } catch {
      /* ignore quota / private mode */
    }
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode((prev) => !prev);
  };

  useEffect(() => {
    // Initialize Facebook Pixel
    ReactPixel.init('1216201373713523');
    
    // Initialize tab visibility detection when app mounts
    const cleanupVisibilityDetection = initializeTabVisibilityDetection();
    // Cleanup when component unmounts
    return () => {
      cleanupVisibilityDetection();
    };
  }, []);

  return (
    <div className="App">
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
      >
        <Router>
          <Routes>
            <Route path='/' element={<ChaimateClubLanding />} />
            <Route path="/home" element={<Home darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/auth/callback" element={<AuthCallback darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/articleship" element={<Articleship />} />
            <Route path="/nishantkumar" element={<DirectChat slug="nishantkumar" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/scannerexpert" element={<DirectChat slug="scannerexpert" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/neerajarora" element={<DirectChat slug="neerajarora" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/aakashkandoi" element={<DirectChat slug="aakashkandoi" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/vanshgoyal" element={<DirectChat slug="vanshgoyal" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/kushallodha" element={<DirectChat slug="kushallodha" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/umeshsharma" element={<DirectChat slug="umeshsharma" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/jksc-audit-expert" element={<DirectChat slug="jksc-audit-expert" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/paraggupta" element={<DirectChat slug="paraggupta" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/gujaratgovt" element={<DirectChat slug="gujaratgovt" darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/call" element={<CallPage />} />
            <Route path="/call/bhupendrapatel" element={<BhupendraPatelCallPage />} />
            <Route path="/call/gujaratgovt" element={<GujaratGovtCallPage />} />
            <Route path="/userdashboard" element={<UserDashboard />} />
            <Route path="/govtdashboard" element={<GovtDashboard />} />
            <Route path="/adani" element={<AdaniDashboard />} />
            <Route path="/LendingKart" element={<LendingKart darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/astrodeepak" element={<AstroDeepak darkMode={darkMode} toggleDarkMode={toggleDarkMode} />} />
            <Route path="/api-docs" element={<ApiDocs />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route
              path="/gmm"
              element={
                <div className="gmm-route-root">
                  <GmmIntel />
                </div>
              }
            />
          </Routes>
        </Router>
      </ErrorBoundary>
    </div>
  );
}

export default App;